<template>
  <v-container fluid class="add-template">
    <v-layout>
      <p>Hoe moet deze nieuwe <em>lijst</em> heten? Geef het bijvoorbeeld de naam van de winkel waar je naartoe gaat.</p>
    </v-layout>
    <v-layout row style="flex-grow:0;">
      <v-flex xs12>
        <v-text-field
          name="input-1"
          label="Typ hier de naam van de lijst"
          id="testing"
          v-model="listName"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { EventBus } from '@/main'
  import { util } from '@/mixins'

  export default {
    name: 'add-list',
    data () {
      return {
        listName: ''
      }
    },
    methods: {
      addList () {
        // ADD VUELIDATE!!!
        if (this.listName.length === 0) return
        const list = {
          id: util.methods.generateID('list_'),
          name: this.listName,
          items: [],
          collectedItems: [],
          suggestions: []
        }
        this.$store.commit('ADD_LIST', list)
        this.listName = ''
        this.$store.dispatch('setCurrentList', list.id)
        this.$router.push({name: 'categories'})
      }
    },
    mounted () {
      EventBus.$on('done-adding-list', () => {
        this.addList()
      })
    }
  }
</script>

<style lang="scss" scoped>
  p {
    font-size: 24px;
    text-align: center;
    em {
      font-weight: 600;
    }
  }

  .add-template {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// AddList.vue?bcb3b06e